import FacebookChatView from './components/facebookChatView.component';

export default function FacebookChatPage() {
  return <FacebookChatView />;
}
